// import transformer from 'transformers/account';
// import store from 'store';
import { makeRequest } from 'utils/requestLogger';
// import config from '../apiConfigs';

export default (referring_user_id) =>
  makeRequest('get', `/api/referrals/user/${referring_user_id}`);



// WEBPACK FOOTER //
// ./src/app/services/account/getReferringUserInformation.js